export enum FeatureName {
  None = 'None',
  CaptionV2 = 'CaptionV2',
  PostPreviewV2 = 'PostPreviewV2',
}

class LocalStorageFeatureToggle {
  set(featureName: `${FeatureName}`, value: boolean) {
    this.validateFeatureName(featureName)

    if (typeof window === 'undefined') {
      return
    }

    try {
      if (value) {
        window.localStorage.setItem(featureName, '1')
      } else {
        window.localStorage.removeItem(featureName)
      }
    } catch {
      return
    }
  }

  get(featureName: `${FeatureName}`) {
    if (typeof window === 'undefined') {
      return false
    }

    try {
      return !!window.localStorage.getItem(featureName)
    } catch {
      return false
    }
  }

  private validateFeatureName(featureName: string) {
    if (!Object.values(FeatureName).includes(featureName as FeatureName)) {
      throw new Error(`Invalid feature name: ${featureName}`)
    }
  }
}

export const localStorageFeatureToggle = new LocalStorageFeatureToggle()
if (typeof window !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(window as any).localStorageFeatureToggle = localStorageFeatureToggle
}
